import { useQuery } from '@tanstack/vue-query'
import Organisation from '@/api/Dara/Organisation'
import Programme from '@/api/Dara/Programme'
import { organisationKeys, programmesKeys } from '@/composable/queries/keys'

export const useOrganisationProgrammeQuery = (
  organisationId: Ref<number>,
  enabled: Ref<boolean> = ref(true),
  isInterviewsHandled?: Ref<boolean>,
) =>
  useQuery({
    queryKey: organisationKeys.programmes(organisationId, isInterviewsHandled),
    queryFn: () => Organisation.getProgrammes(organisationId.value, isInterviewsHandled?.value),
    enabled,
  })

export const useProgrammeReportsQuery = (
  programmeId: Ref<number>,
  enabled: Ref<boolean> = ref(true),
) =>
  useQuery({
    queryKey: programmesKeys.reports(programmeId),
    queryFn: () => Programme.getReports(programmeId.value),
    enabled,
  })
